<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/goPlSE/images/9781439652411.jpg?1688985071933" alt="This image is the cover for the book Richmond, Images of America"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Richmond, Images of America
      </h1>
      <p class="bookDescription body article font2">
        <p>Founded by Quakers from North Carolina more than 200 years ago, Richmond boasts a rich and colorful history. White and black migrants from older parts of the United States joined emigrants from Ireland and Germany to create a diverse, flourishing, and at times contentious community. Railroads, the Whitewater Canal, and the National Road laid the foundations for economic growth before the Civil War, and Richmond grew steadily in population and prosperity from the Civil War until the late 20th century. Local folklore claims that at one time the city had more millionaires in proportion to population than any other place in the United States. While erecting remarkable homes and buildings, founding enduring institutions like schools, churches, and museums, and supporting at one time as many as six newspapers, Richmond produced memorable and colorful characters who left their mark not just in Richmond and Indiana, but around the United States.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Susan E. King, Thomas D. Hamm
      </h2>
      
      <p class="authorDescription body article">Susan E. King, an archivist at Richmond's Morrisson-Reeves Library, and Thomas D. Hamm, a professor of history and archivist at Earlham College, have drawn from their institutions' collections and others to create a photographic portrait of Richmond since its founding.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3361c3a0